/**
 * Imports the BASE URL from the config.
 */
import { FH_CONFIG } from '../config.js';

/**
 * Imports the Freighthub API.
 */
import { api } from '../api';

export default {
    /**
     * GET
     */
    getVehicles: function (params) {
        return api.get('/carrier/gps/vehicles/', { params: params });
    },

    /**
     * PUT
     */
    putVehicle: function ({ id, basic_colour, body_style, gross_vehicle_weight, make, model, plate, power, second_colour, special_equipments, sub_model, tare_weight, type, edi_name }) {
        return api.put('/carrier/gps/vehicles/' + id,
            {
                basic_colour,
                body_style,
                gross_vehicle_weight,
                make,
                model,
                plate,
                power,
                second_colour,
                special_equipments,
                sub_model,
                tare_weight,
                type,
                edi_name
            }
        );
    },
}